import { woodworkProjectManifestUrl } from '../config/media'
import type { WoodworkManifestProject } from '../content/woodworkManifest'

export async function getWoodworkProjectManifest(
  projectId: string
): Promise<WoodworkManifestProject> {
  const url = woodworkProjectManifestUrl(projectId)
  const response = await fetch(url, {
    headers: { Accept: 'application/json' }
  })

  if (!response.ok) {
    throw new Error(`Woodwork project manifest ${response.status} at ${url}`)
  }

  const manifest = (await response.json()) as WoodworkManifestProject
  if (manifest.id !== projectId) {
    throw new Error(`Project manifest id mismatch: expected ${projectId}, got ${manifest.id}`)
  }

  return manifest
}
